import React, { Component } from "react";
import { get, post } from '../../custom_libraries/serverRequests';
import urls from '../../custom_libraries/urls';
import '../adminDash.css';
import { Link } from 'react-router-dom';
import EditDeviceIcon from '../../assets/icons8-edit-device-info.png';
import Deleteicon from '../../assets/icons8-trash-50.png'; 
// import SCHEDULAR from '../../assets/icons8-schedule-48.png'; 
import Button from '@mui/material/Button';
import hdd3 from '../../assets/icons8-hdd-48 (2).png';
import Alert from '@mui/material/Alert';
import CheckIcon from '@mui/icons-material/Check';
import Expandicon from '../../assets/icons8-expand-32.png';
import LiveCam from '../../assets/icons8-wifi-live.png' 
import globalVariables from "../../custom_libraries/globalVariables";
import withNavigate from "../../Global_files/WithNavigate";
import TestConnection from '../../assets/icons8-test-connection-64.png';
import Backdrop from '@mui/material/Backdrop';
// import CircularProgress from '@mui/material/CircularProgress';
import WebLogo from '../../assets/circular-CHM-logo.png'
// import Mute_Unmute_icon from '../../assets/icons8-disable-alarm-24.png';
import DialogBox from '../DialogBox';


class DevicesList extends Component {
  constructor(props) {
    super(props);
    this.state = {
      cameras: [],
      devices: [],
      searchInput: "",
      currentPage: 1,
      rowsPerPage: 10,
      editToggle:false,

      EditDeviceName: "",
      EditDeviceType: "", // default null to select from list of valid options only
      device_type_list:[],
      EditIpAddress: "",
      EditProtocol: "",
      EditPortNumber: "",
      EditDeviceUsername: "",
      EditDevicePassword: "",
      client:"",

      error: false,
      success: false,
      success1: false,
      success2: false,
      error1: false,
      error2: false,
      Selected_Device_Id:'',
      expandedRow: null,
      site_wise_devices:[],
      site_id: null,
      site_name:null,

      showModal: false, // Controls modal visibility
      responseMessage: "", // Stores the response message
      response_data: {},
      open_progress_bar: false,
      // open_MuteUnmute_Dialogue: false,
      mute: false,
      unmute: false,
      muteResponseMessage:'',

      confirmDialog: {
        isOpen: false,
        title: '',
        subtitle: '',
      },

      user_type: ''

    };
  }

  componentDidMount() {
    const storedUserType = localStorage.getItem(globalVariables.USER_TYPE);
    this.setState({user_type : storedUserType}); //get user type of logged in user to set the edit.delete permission of device

    // Add event listener for keydown
    document.addEventListener("keydown", this.handleKeyDown);
    this.getDevicesList();
    this.fetchDeviceTypes(); // load this function for edit facility
    const site_id = localStorage.getItem(globalVariables.SITE_ID);
    const site_name = localStorage.getItem(globalVariables.SITE_NAME);
    if (site_id) {
        this.setState({ site_id }); // Save site_id to state
        this.setState({site_name})
        this.getDevicesListById(site_id);
    }
  }

  componentWillUnmount() {
    //Remove the site wise list shown when navigated to another page or page reloads.
    localStorage.removeItem(globalVariables.SITE_ID);
    // Remove event listener for keydown
    document.removeEventListener("keydown", this.handleKeyDown);
  }

  handleKeyDown = (event) => {
    if (event.key === "Escape") {
      // Close modal when Esc key is pressed
      this.handleCloseModal();
    }
  };

  getDevicesListById = async (site_id) => {
    // let site_id = localStorage.getItem(globalVariables.SITE_ID);
    // this.setState({ site_id: site_id });
    let access_tocken = localStorage.getItem(globalVariables.AUTH_TOKEN)
    console.log("--------auth tocken---------", access_tocken);
    let headers = {
        'content-type': 'application/json',
        'Authorization': `Bearer ${access_tocken}`
    }
    console.log("---------globalVariables site_id--------", site_id);
    try {
      const url = urls.GET_DEVICES_BY_SITE(site_id);
      const response = await get(url, headers); // Replace with your actual API call
      console.log("url----------->", url);
      console.log("API Response:----------getDevicesListById site_it--------------------------------->>>", response)

      if (response) {
        console.log("res",response)
        this.setState({ site_wise_devices: response });
      } else {
        console.error("No data returned from the API");
      }
    } catch (error) {
      console.error("Error fetching devices from API:", error);
    }
  };

  getDevicesList = async () => {
    try {
      let access_tocken = localStorage.getItem(globalVariables.AUTH_TOKEN)
      console.log("--------auth tocken---------", access_tocken);
      let headers = {
          'content-type': 'application/json',
          'Authorization': `Bearer ${access_tocken}`
      }
      // const response = await get(urls.GET_DEVICES, headers); // API call
      const response = await get(urls.GET_DEVICE_BY_DEALER, headers); //Api for devices w.r.t dealer's registered sites.
      console.log("API Response:", response)

      if (response) {
        console.log("res",response)
        this.setState({ devices: response });
      } else {
        console.error("No data returned from the API");
      }
    } catch (error) {
      console.error("Error fetching devices from API:", error);
    }
  };

  handleChangePage = (newPage) => {
    this.setState({ currentPage: newPage });
  };

  handleSearchInputChange = (e) => {
    this.setState({ searchInput: e.target.value });
  };

  handleInputChange = (e) => {
    const { name, value } = e.target;
    this.setState({ [name]: value });
  };

  closePopup = () => {
    this.setState({ editToggle: false });
  };

  LoadSelectedDeviceInfo = async (deviceId) => {
    this.setState({ editToggle: true });
    this.setState({Selected_Device_Id : deviceId})
    try {
      let access_tocken = localStorage.getItem(globalVariables.AUTH_TOKEN)
      console.log("--------auth tocken---------", access_tocken);
      let headers = {
          'content-type': 'application/json',
          'Authorization': `Bearer ${access_tocken}`
      }
      const url = urls.DEVICE_DETAILS(deviceId);  // static method defined in urls.jsx: passed the deviceId of selected device (device row)      const response = await get(url);
      const response = await get(url, headers); // Perform the API call using the constructed URL
      console.log(`API Response for LoadSelectedDeviceInfo ${deviceId}:`, response);

      if (response && Object.keys(response).length > 0) {
        console.log(`API Response for LoadSelectedDeviceInfo ${deviceId}:`, response);
        this.setState({ 
          EditDeviceName: response.device_name || "",
          EditDeviceType: response.device_type || "",
          EditIpAddress: response.ip_address || "",
          EditRTSPAddress: response.rtsp_port || "",
          EditProtocol: response.protocol || "",
          EditPortNumber: response.port_number || "",
          EditDeviceUsername: response.device_username || "",
          EditDevicePassword: response.device_password || "",
          client : response.client || "",
         });

      } else {
        console.error("No valid data returned from the get-camera API");
        // this.setState({ cameras: [] }); // Ensure cameras list is cleared for invalid data
      }
    } catch (error) {
      console.error("Error fetching cameras from API:", error);
      // this.setState({ cameras: [] }); // Clear the cameras list in case of error
    }
  };

  fetchDeviceTypes = async () => {  //fetch device types from server
        try {
          let access_tocken = localStorage.getItem(globalVariables.AUTH_TOKEN)
          console.log("--------auth tocken---------", access_tocken);
          let headers = {
              'content-type': 'application/json',
              'Authorization': `Bearer ${access_tocken}`
          }
            console.log("Fetching data from:", urls.DEVICE_TYPE_LIST);
            const response = await get(urls.DEVICE_TYPE_LIST, headers);
            console.log("Client list Response in Adddevice-----:", response);
    
            if (!response || !Array.isArray(response)) {
                console.error("Invalid response format or empty list.");
                this.setState({ device_type_list: [] });
                return;
            }
    
            this.setState({ device_type_list: response }); // Directly use the array from your response
            console.log("Updated state with device types list:", this.state.device_type_list);
        } catch (error) {
            console.error("Error in fetchDeviceTypes:", error);
            this.setState({ device_type_list: [] });
        }
  };

  handleDelete =  async (selected_device_id) => {      
      try {
        let access_tocken = localStorage.getItem(globalVariables.AUTH_TOKEN)
        const url = urls.DEVICE_DETAILS(selected_device_id);  // static method defined in urls.jsx: passed the deviceId of selected device (device row)      const response = await get(url);
        const response = await fetch(url, {
          method: 'DELETE',
          headers: {
            'content-Type': 'application/json',
            'Authorization': `Bearer ${access_tocken}`,
          },
          
        });
        console.log("reponse in delete elevator ------------->", response);
        if (response.ok) {

        //   console.log("reponse.ok ------------->", response.ok);

          // const data =  response.json(); 
          console.log(`Elevator with id ${selected_device_id} deleted successfully`, response);
          // window.location.reload();
          this.getDevicesList()
          } 
        else {
              const errorMessage =  response.statusText; // Read the error message from response body
        alert(`Failed to delete user with ID ${selected_device_id}: ${errorMessage}`);

        }
      } catch (error) {
        console.error('Error during delete request:', error);
      }
   
  }

  handleDeleteCamera =  async (selected_camera_id) => {      
      try {
        let access_tocken = localStorage.getItem(globalVariables.AUTH_TOKEN)
        const url = urls.CAMERA_DETAILS(selected_camera_id);  // static method defined in urls.jsx: passed the deviceId of selected device (device row)      const response = await get(url);
        const response = await fetch(url, {
          method: 'DELETE',
          headers: {
            'content-Type': 'application/json',
            'Authorization': `Bearer ${access_tocken}`,
          },
          
        });
        console.log("reponse in delete elevator ------------->", response);
        if (response.status==204) {

         console.log("reponse.ok ------------->", response.ok);

          // const data =  response.json(); 
         window.location.reload();
         // this.getDevicesList()
          } 
        else {
              const errorMessage =  response.statusText; // Read the error message from response body
        alert(`Failed to delete user with ID ${selected_camera_id}: ${errorMessage}`);

        }
      } catch (error) {
        console.error('Error during delete request:', error);
      }
   
  }


   /** 
     * getCamerasList() function fetches the camera list w.r.t selected device (row from device list table). this function gets invoked from when clicked on the row of device list table.
    **/
    getCamerasList = async (deviceId) => {
      try {
        let access_tocken = localStorage.getItem(globalVariables.AUTH_TOKEN)
          console.log("--------auth tocken---------", access_tocken);
          let headers = {
              'content-type': 'application/json',
              'Authorization': `Bearer ${access_tocken}`
          }
        const url = urls.CAMERAS_BY_DEVICE(deviceId);  // static method defined in urls.jsx: passed the deviceId of selected device (device row)      const response = await get(url);
        const response = await get(url, headers); // Perform the API call using the constructed URL
        if (Array.isArray(response) && response.length > 0) {
          console.log(`API Response for device ${deviceId}:`, response);
          this.setState({ cameras: response });
  
        } else {
          console.error("No valid data returned from the get-camera API");
          alert("No cameras found for the selected device.");
          this.setState({ cameras: [] }); // Ensure cameras list is cleared for invalid data
        }
      } catch (error) {
        console.error("Error fetching cameras from API:", error);
        this.setState({ cameras: [] }); // Clear the cameras list in case of error
      }
    };

  // Handler to toggle dropdown table for a device row
     handleRowClick = async(deviceId) => {
  
      let device_details = await get(urls.DEVICE_DETAILS(deviceId))
  
      console.log("device_Details",device_details)
  
      this.setState({
        device_details:device_details
      })
  
      this.setState(
        (prevState) => ({
          expandedRow: prevState.expandedRow === deviceId ? null : deviceId, // Toggle the row
        }),
        () => {
          if (this.state.expandedRow) {
            this.getCamerasList(deviceId); // Fetch data only when the row is expanded
          }
        }
      );
    };  

  handleSaveEditedInfo =  async (selected_device_id) => {

    let access_tocken = localStorage.getItem(globalVariables.AUTH_TOKEN)

      let data = {
        "device_name": this.state.EditDeviceName,
        "device_type": this.state.EditDeviceType,
        "client" : this.state.client,
        "ip_address": this.state.EditIpAddress,
        "rtsp_port": this.state.EditRTSPAddress,
        "protocol": this.state.EditProtocol,
        "port_number": this.state.EditPortNumber,
        "device_username": this.state.EditDeviceUsername,
        "device_password": this.state.EditDevicePassword    
      }
      console.log("-----JSON DATA -------->",data);
      let post_data = JSON.stringify(data);
      
      try {
        const url = urls.DEVICE_DETAILS(selected_device_id);  // static method defined in urls.jsx: passed the deviceId of selected device (device row)      const response = await get(url);
        const response = await fetch(url, {
          method: 'PUT',
          headers: {
            'Content-Type': 'application/json', // Specify the content type
            'Authorization': `Bearer ${access_tocken}` // Optional: If your API requires an authorization token
          },
          body: post_data,
          
        });
        console.log("reponse in edit device info ------------->", response);
        if (response.ok) {

        //   console.log("reponse.ok ------------->", response.ok);
          this.setState({success: true});

          // Delay before reload to allow user to see the alert
          setTimeout(() => {
            window.location.reload();
        }, 1000); // 3 seconds delay
          } 
        else {
              // const errorMessage =  response.statusText; // Read the error message from response body
        // alert(`Failed to delete user with ID ${selected_device_id}: ${errorMessage}`);
        this.setState({error: true});

        }
      } catch (error) {
        console.error('Error during delete request:', error);
      }
   
  }

      // Method to handle modal close
  handleCloseModal = () => {
    this.setState({ showModal: false }, () => {
        // Reload the page after modal is closed
        window.location.reload();
    });
  };

  // Handle form submission
  TestConnection = async ( device) => {
      // e.preventDefault();
      this.startLoading()
      // Prepare payload
      let deviceData = {
        device_name: device.device_name,
        device_type: device.device_type,
        sitedb: device.sitedb,
        ip_address: device.ip_address,
        protocol: device.protocol, // Convert to lowercase and remove '://'
        port_number: device.port_number,
        device_username: device.device_username,
        device_password: device.device_password,
        };
        const data = JSON.stringify(deviceData)
        console.log("data",data)


      try{
        let access_tocken = localStorage.getItem(globalVariables.AUTH_TOKEN)
        // console.log("--------auth tocken---------", access_tocken);
        let headers = {
            // 'content-type': 'application/json',
            'Content-Type': 'application/json; charset=UTF-8',
            'Authorization': `Bearer ${access_tocken}`
        }
        // Call custom get method
        let response = await post(urls.TEST_CONNECTION, data, headers)

        console.log("url",urls.TEST_CONNECTION)
        console.log("data res",response)
        this.stopLoading()
        if(response!=false)
            {
                this.setState({
                    success1: true,
                    showModal: true, // Show the modal
                    responseMessage: response.responseMessage,
                    response_data: response.response_data, // Store detailed response data
                });

            }
            else if(response === "Failed to fetch info from Device!" || response == false){
                this.setState({
                  error1: true,
                  showModal: true,
                  });
            }
        }catch (error) {
            console.error('Error:', error);
            // alert('An error occurred while creating the device.');
            // this.setState({ error: true});
        }
  };

  startLoading = () => {
    console.log("startloading")
    this.setState({ open_progress_bar: true })
  }

  stopLoading = () => {
    this.setState({ open_progress_bar: false })
  }

  openDialog = (onConfirm) => {
    this.setState({
      confirmDialog: {
        isOpen: true,
        title: 'Confirm Action',
        subtitle: "Are you sure, you want to delete this?",
        onConfirm
      },
    });
  };

  closeDialog = () => {
    this.setState({
      confirmDialog: {
        ...this.state.confirmDialog,
        isOpen: false,
      },
    });
  };

  getCurrentTimeInDeviceTimezone = (deviceUtcOffset) => {
    if (deviceUtcOffset === undefined || deviceUtcOffset === null) {
      return "Time unavailable"; // Fallback message
  }
    try {
      // Ensure deviceUtcOffset is in hours; convert to minutes if needed
      const offsetMinutes = deviceUtcOffset * 60;

      // Get the current UTC time
      const now = new Date();

      // Calculate the device's local time
      const deviceTime = new Date(now.getTime() + offsetMinutes * 60 * 1000);

      return deviceTime.toLocaleString(); // Return the device's local time in readable format
  } catch (error) {
      console.error("Error calculating device time:", error);
      return "Error calculating time";
  }
}

  render() {
    const { devices,expandedRow, cameras,currentPage, rowsPerPage, searchInput, editToggle, device_type_list,
      EditDeviceName, EditDeviceType, EditProtocol, EditPortNumber, EditIpAddress, EditRTSPAddress,
      EditDeviceUsername, EditDevicePassword, success, success1, error, error1,Selected_Device_Id,
      site_wise_devices, showModal, responseMessage, response_data, confirmDialog, site_id, site_name, user_type } = this.state;

      // Filter devices based on search input
      const filteredDevices = Array.isArray(devices)
        ? devices.filter((device) =>
            device.device_name?.toLowerCase().includes(searchInput?.toLowerCase() ?? "")
          )
        : [];

      // Filter cameras based on search input
      const filteredCameras = Array.isArray(cameras)
        ? cameras.filter((camera) =>
            camera.camera_name?.toLowerCase().includes(searchInput?.toLowerCase() ?? "")
          )
        : [];

      // Filter site-wise devices based on search input
      const filteredSiteDevices = Array.isArray(site_wise_devices)
        ? site_wise_devices.filter((device) =>
            device.device_name?.toLowerCase().includes(searchInput?.toLowerCase() ?? "")
          )
        : [];

    // Pagination logic
    const indexOfLastRow = currentPage * rowsPerPage;
    const indexOfFirstRow = indexOfLastRow - rowsPerPage;
    const currentRows = filteredDevices.slice(indexOfFirstRow, indexOfLastRow);

     //get global variable of site_id
    //  const site_id = localStorage.getItem(globalVariables.SITE_ID);

    return (
      <div style={{ display: 'flex', flexDirection: 'column' }}>
        <div style={{height:'40px', backgroundColor:'#f3f3f3', color:'black', marginLeft: '11%', fontSize:'16px', fontWeight:'bold', display:'flex', alignItems:'center', marginBottom:'8px'}}>
         <Link to="/system-overview"><span style={{ paddingLeft:'20px'}}>Dashboard</span> </Link>&ensp; &gt; &ensp;Device Manager &ensp;&gt;&ensp; Devices List
      </div>
          <div  style={{marginLeft:'11%', padding: '3px', overflowY: 'auto' }}>
          <div>
            <div className="search-container">
            <span>
              {/* <span style={{border: '1px solid gray', width:'25%', padding:'5px'}}> */}
                {/* <button style={{backgroundColor:'#5b83ae', color:'white'}}> Excel </button>&nbsp; <button style={{backgroundColor:'#5b83ae', color:'white'}}> PDF </button> */}
                </span>
              <input
                type="text"
                id="search-input"
                placeholder="Search by device name"
                value={searchInput}
                onChange={this.handleSearchInputChange}
              />
            </div>

            {site_wise_devices && site_wise_devices.length > 0 && (
              console.log("site_wise_devices",site_id),
              <div>
                <h4>Devices for Site : {site_name}</h4>
                <table id="devices" style={{ width: "100%", minWidth: "900px", borderCollapse: "collapse", marginBottom:'15px' }}>
                  <thead>
                    <tr>
                      <th>Action</th>
                      <th>Device Name</th>
                      <th>Site Name</th>
                      <th>Device Type</th>
                      <th>Model</th>
                      <th>Hardware Version</th>
                      <th>HDD Storage</th>
                      <th>Storage Health</th>
                      <th>System Channel max</th>
                      <th>Active Cameras</th>
                      <th>IP Address</th>
                      {/* <th>Port no.</th> */}
                      
                      <th>Device Username</th>
                      <th>Device Password</th>
                      {/* <th>Time <br/> (Device/Time) </th> */}
                    </tr>
                  </thead>
                  <tbody>
                      {filteredSiteDevices.map((device) => {
                          // Split the created_at string to separate date and time
                          // const formattedDate = device.created_at.replace("T", " ").replace("Z", "");
                          
                          return (
                          <tr key={device.id}>
                              <td>
                                <span style={{ display: 'flex', justifyContent: 'center', gap:'8px'}}>
                                  {user_type === "DealerUser" && (
                                    <> 
                                    <img src={EditDeviceIcon} alt="edit-device-info" width="27px" title="edit info" id='delete_icon' onClick={() => this.LoadSelectedDeviceInfo(device.id)}/> 
                                    <img width="20" height="18" src={Deleteicon} id='delete_icon' alt="delIcon" title='delete device' onClick={() => this.openDialog(() => this.handleDelete(device.id))}/>
                                    </>
                                  )}
                                  <img src={TestConnection} alt="" width="22" height="20" title="Test Connection" id='delete_icon' onClick={()=> this.TestConnection(device)}/>
                                </span>
                              </td>
                              <td>{device.device_name}</td>
                              <td>{device.site_name || "N/A"}</td>
                              <td>{device.device_type_name}</td>
                              <td>{device.model}</td>
                              <td>{device.hardware_version}</td>
                              <td>{device.hdd_storage}</td>
                              <td style={{textAlign:'center'}}>
                              {device.status === 'active' && device.storage_health === 'ok' ? (
                                        <span>
                                            <img src={hdd3} alt="storage-health" title="HDD Status Ok" width="26px" />
                                        </span>
                                    ) : (
                                        "N/A"
                                    )}   
                                          
                              </td>

                               
                              <td style={{textAlign:'center'}}>{device.chl_max_count}</td>
                              <td style={{textAlign:'center'}}>{device.total_cameras}</td>
                              <td>{device.ip_address}</td>
                              {/* <td>{device.port_number}</td> */}
                              
                              <td>{device.device_username}</td>
                              <td>{device.device_password}</td>                                                        
                          </tr>
                          );
                      })}
                    {currentRows.length === 0 && (
                      <tr>
                        <td colSpan="15" style={{ textAlign: "center", padding: "20px" }}>
                          No devices found.
                        </td>
                      </tr>
                    )}
                  </tbody>
                </table>
              </div>
              )
            }
            <div>
              <h4>All Devices</h4>
              <table id="devices" style={{ width: "100%", minWidth: "900px", borderCollapse: "collapse" }}>
                <thead>              
                  <tr>
                    <th>Action</th>
                    <th>Group Name</th>
                    <th>Site Name</th>
                    <th>Device Type</th>
                    <th>Model</th>
                    <th>Hardware Version</th>
                    <th>HDD Storage</th>
                    <th>Storage Health</th>
                    <th>System Channel Max</th>
                    <th>Active Cameras</th>
                    <th>IP Address</th>
                    {/* <th>Port no.</th>
                    <th>Location</th> */}
                    <th>Device Username</th>
                    <th>Device Password</th>
                    {/* <th>Device Time</th> */}
                  </tr>
                </thead>
                <tbody>
                    {currentRows.map((device) => {
                        // Split the created_at string to separate date and time
                        // const formattedDate = device.created_at.replace("T", " ").replace("Z", "");
                        
                        return (
                          <React.Fragment key={device.id}>

                          
                        <tr key={device.id}>
                            <td>
                              <span style={{ display: 'flex', justifyContent: 'center', gap:'8px'}}>
                                {user_type === "DealerUser" && (
                                  <>
                                    <img src={EditDeviceIcon} alt="edit-device-info" width="27px" title="edit info" id='delete_icon' onClick={() => this.LoadSelectedDeviceInfo(device.id)}/> 
                                    <img width="20" height="18" src={Deleteicon} id='delete_icon' alt="delIcon" title='delete device' onClick={() => this.openDialog(() => this.handleDelete(device.id))}/> 
                                  </>
                                )}
                                <img src={TestConnection} alt="test-connection" width="22" height="20" title="Test Connection" id='delete_icon' onClick={()=> this.TestConnection(device)}/>
                              </span>
                            </td>
                            
                            <td id="table-cell-device" onClick={() => this.handleRowClick(device.id)}>
                              {device.total_cameras > 0 && (
                                <>
                                  <img src={Expandicon} alt="expand row" width={15} height={15} />
                                  &ensp;
                                </>
                              )}
                              {device.device_name}
                            </td>  

                            <td>{device.site_name}</td>
                            <td>{device.device_type_name}</td>
                            <td>{device.model}</td>
                            <td>{device.hardware_version}</td>
                            <td>{device.hdd_storage}</td>
                            {/* <td>{device.storage_health}</td> */}
                              
                            <td style={{textAlign:'center'}}>
                              {device.status === 'active' && device.storage_health === 'ok' ? (
                                        <span>
                                            <img src={hdd3} alt="storage-health" title="HDD Status Ok" width="26px" />
                                        </span>
                                    ) : (
                                        "N/A"
                                    )}   
                            </td>
                            <td style={{textAlign:'center'}}>{device.chl_max_count}</td>
                            <td style={{textAlign:'center'}}>{device.total_cameras}</td>
                            <td>{device.ip_address}</td>
                            {/* <td>{device.port_number}</td> */}
                            {/* <td>{device.location || "N/A"}</td> */}
                            <td>{device.device_username}</td>
                            <td>{device.device_password}</td>
                            {/* <td style={{ color: device.time_zone_match ? "green" : "red" }}>
                              {device.time_zone_match ? (
                                  "Timezone matches"
                              ) : (
                                  <>
                                      <span>Timezone mismatch</span>
                                      <br />
                                      <span> <b>
                                          Current time: {device.device_utc_offset !== undefined && device.device_utc_offset !== null 
                                              ? this.getCurrentTimeInDeviceTimezone(device.device_utc_offset) 
                                              : "Time unavailable"} </b>
                                      </span>
                                  </>
                              )}
                            </td> */}
                        </tr>
                        {/* Dropdown Table */}
                        {expandedRow === device.id && cameras.length > 0 && (
                        <tr>
                          <td colSpan="10" >
                            {/* <div style={{ Width: "100%" }}> */}
                            <table
                              id="cameras"
                              style={{
                                width: "100%",
                                // maxWidth: "1200px", // Adjust as needed
                                borderCollapse: "collapse",
                                marginTop: "10px",
                                textAlign:'center',
                              }}
                            >
                              <thead>
                                <tr>
                                  {/* <th> Action </th> */}
                                  <th>Camera Name</th>
                                  <th>Channel ID</th>
                                  {/* <th>Camera Type</th> */}
                                  <th>Status</th>
                                  {/* <th>Image Quality</th> */}
                                  {/* <th>Recording</th> */}
                                  {/* <th>IP Address</th>
                                  <th>Location</th>
                                  <th>Protocol</th>
                                  <th>Port</th> */}
                                  {/* <th>Action</th> */}
                                </tr>
                              </thead>
                              <tbody>
                                {cameras.map((camera) => (
                                  <tr key={camera.id}>
                                     {/* <td> 
                            <img width="20" height="18" src={Deleteicon} id='delete_icon' alt="delIcon" title='delete camera' onClick={() => this.openDialog(() => this.handleDeleteCamera(camera.id))}/> 
                            </td> */}
                                    <td>{camera.camera_name}</td>
                                    <td>{camera.channel_id}</td>
                                    {/* <td>{camera.camera_type}</td> */}
                                    <td>{camera.status === 'online' ? (
                                          <span> <img src={LiveCam} alt="live-cam" width="21px"/> </span>
                                        ) :null}</td>
                                    {/* <td>{camera.image_quality}</td> */}
                                    {/* <td>
                                        {camera.recording_days < this.state.device_details.recording_policy_days ? (
                                            <span style={{ color: 'red' }}>
                                                Only found <b>{camera.recording_days} days</b> of recordings <br />
                                                Policy: <b>{this.state.device_details.recording_policy_days ? `${this.state.device_details.recording_policy_days} days` : 'No policy defined'}</b>
                                            </span>
                                        ) : (
                                            <span style={{ color: 'green' }}>
                                                Found <b>{camera.recording_days} days</b> of recordings <br />
                                                Policy: <b>{this.state.device_details.recording_policy_days ? `${this.state.device_details.recording_policy_days} days` : 'No policy defined'}</b>
                                            </span>
                                        )}
                                    </td> */}


                                    {/* <td>{camera.ip_address}</td>
                                    <td>{camera.location}</td>
                                    <td>{camera.protocol}</td>
                                    <td>{camera.port}</td> */}
                                    
                                  </tr>
                                ))}

                              </tbody>
                            </table>
                            {/* </div> */}
                          </td>
                          
                        </tr>
                        )}
                        </React.Fragment>
                        );
                    })}
                  {currentRows.length === 0 && (
                    <tr>
                      <td colSpan="15" style={{ textAlign: "center", padding: "20px" }}>
                        No devices found.
                      </td>
                    </tr>
                  )}
                </tbody>
              </table>
            </div>
            {editToggle &&  (
              <>
                {/* Background Overlay */}
                <div style={{position: "fixed",top: 0, left: 0, width: "100%", height: "100%", backgroundColor: "rgba(0, 0, 0, 0.3)", // Dim effect
                  // backdropFilter: "blur(3px)", // Blur effect
                    zIndex: 999, // Ensure it's below the popup
                  }}
                  onClick={this.closePopup} // Close the popup when clicking on the overlay
                >
                </div>
                <div style={{
                  position: "absolute",
                  top: "54%",
                  left: "75%",
                  transform: "translate(-50%, -50%)",
                  backgroundColor: "white",
                  boxShadow: "0px 4px 6px rgba(0, 0, 0, 0.1)",
                  padding: "20px",
                  zIndex: 1000,
                  width: "73%",
                  height:'90%',
                  maxWidth: "700px",
                  borderRadius: "8px",
                }} >
                  <div className="form-section" >
                  {/* <h3 style={{color:'#001668', textAlign:'center', backgroundColor:'#dbeffd', height:'1cm', alignContent:'center'}}>Edit Device Info</h3> */}
                  <h3 style={{color:'#001668', textAlign:'center', backgroundColor:'#d1dcfe', height:'1cm', alignContent:'center'}}>Edit Device Info</h3>

                  {/* {error && <div className="alert alert-danger" style={{color :'#d9645c', fontSize:'small'}}>{error}</div>}<br/>
                  {success && <div className="alert alert-success">{success}</div>} */}
                  { error ? (
                                <Alert severity="error">Server Error! Device Info was not edited!</Alert>
                            ) : success ? (
                                <Alert icon={<CheckIcon fontSize="inherit" />} severity="success">
                                    "Device Info edited successfully."
                                </Alert>
                            ) : null}
                        <div className='form-group-device-edit'>
                          <label htmlFor="user_name">Device name <span style={{color:'red'}}>*</span>: &nbsp;</label>
                          <input
                              type="text"
                              name="EditDeviceName"
                              value={EditDeviceName || ""}
                              onChange={this.handleInputChange}
                              style={{ width: '350px', height: '0.7cm' }}
                          />
                          </div>
                          <div className='form-group-device-edit'>
                          <label htmlFor="user_name">Device Type <span style={{color:'red'}}>*</span>: &nbsp;</label>
                          <select
                              name="EditDeviceType"
                              placeholder="Device Type"
                              value={EditDeviceType || ""}
                              onChange={this.handleInputChange}
                              style={{ width: '360px', height: '0.9cm' }}
                          >
                              <option value="" disabled>Select Device Type</option>
                              {(device_type_list|| []).map((type) => (
                                  <option key={type.id} value={type.id}>
                                      {type.type_name}
                                  </option>
                              ))}
                          </select>
                          </div>
                          <div className='form-group-device-edit'>
                          <label htmlFor="user_name">IP Address <span style={{color:'red'}}>*</span>: &nbsp;</label>
                          <input
                              type="text"
                              name="EditIpAddress"
                              placeholder="IP Address"
                              value={EditIpAddress || ""}
                              onChange={this.handleInputChange}
                              style={{ width: '350px', height: '0.7cm' }}
                          />
                          </div>
                          <div className='form-group-device-edit'>
                          <label htmlFor="user_name">RTSP <span style={{color:'red'}}>*</span>: &nbsp;</label>
                          <input
                              type="text"
                              name="EditRTSPAddress"
                              placeholder="RTSP "
                              value={EditRTSPAddress || ""}
                              onChange={this.handleInputChange}
                              style={{ width: '350px', height: '0.7cm' }}
                          />
                          </div>
                          <div className='form-group-device-edit'>
                          <label htmlFor="user_name">Protocol <span style={{color:'red'}}>*</span>: &nbsp;</label>
                          <select
                              name="EditProtocol"
                              value={EditProtocol || ""}
                              onChange={this.handleInputChange}
                              style={{ width: '360px', height: '0.9cm' }}
                          >
                          <option value="" disabled>Select Server Protocol</option>
                          <option value="HTTP://">HTTP://</option>
                          <option value="HTTPS://">HTTPS://</option>
                          <option value="RTSP://">RTSP://</option>
                          </select>
                          </div>
                          <div className='form-group-device-edit'>
                          <label htmlFor="user_name">Server Port Number<span style={{color:'red'}}>*</span>: &nbsp;</label>
                          <input
                              type="text"
                              name="EditPortNumber"
                              value={EditPortNumber || ""}
                              onChange={this.handleInputChange}
                              style={{ width: '350px', height: '0.7cm' }}
                          />
                          </div>
                          <div className='form-group-device-edit'>
                          <label htmlFor="user_name">Device Username<span style={{color:'red'}}>*</span>: &nbsp;</label>
                          <input
                              type="text"
                              name="EditDeviceUsername"
                              value={EditDeviceUsername || ""}
                              onChange={this.handleInputChange}
                              style={{ width: '350px', height: '0.7cm' }}
                          />
                          </div>
                          <div className='form-group-device-edit'>
                          <label htmlFor="user_name">Device Password<span style={{color:'red'}}>*</span>: &nbsp;</label>
                          <input
                              type="password"
                              name="EditDevicePassword"
                              value={EditDevicePassword || ""}
                              onChange={this.handleInputChange}
                              style={{ width: '350px', height: '0.7cm' }}
                          />
                          </div>
                        <div style={{display:'flex', justifyContent:'right', gap:'5px', marginTop:'15px'}}>
                          <Button type="button" onClick={() => this.handleSaveEditedInfo(Selected_Device_Id)} style={{width:'0.8cm', height:'0.7cm', backgroundColor:'#326388', color:'white'}}> Save </Button>
                          <Button type="button" onClick={this.closePopup} style={{width:'0.8cm', height:'0.7cm', backgroundColor:'#e02e2e', color:'white'}}> Cancel </Button>
                        </div>
                  </div>
                </div> 
              </>
            )}
            {showModal && (
                        <div className="modal-device-add">
                            <div className="modal-content">
                                <button className="close-button" onClick={this.handleCloseModal}>
                                    &times;
                                </button>
                                
                                  {error1 ? (
                                  <Alert severity="error"><h3>{responseMessage} Device is not reachable!</h3></Alert>
                              ) : success1 ? (
                                  <Alert icon={<CheckIcon fontSize="inherit" />} severity="success">
                                      <h3>{responseMessage}</h3>
                                  </Alert>
                              ) : null}

                                {response_data && typeof response_data === "object" ? (
                                    <div>
                                        {/* Render Device Info */}
                                        {response_data.device_info && (
                                            <div>
                                            <h4>Device Info</h4>
                                            <ul>
                                                {Object.entries(response_data.device_info).map(([key, value]) => (
                                                    <li key={key}>
                                                        <strong>{key.replace(/_/g, " ")}:</strong> <span style={{ color: value ? "green" : "red",}}> {value?.toString() || "N/A"}</span>
                                                    </li>
                                                ))}
                                            </ul>
                                        </div>
                                    )}
                        
                                    {/* Render Disk Info */}
                                    {response_data.disk_info && (
                                        <div>
                                            <h4>Disk Info</h4>
                                            <ul>
                                                {Object.entries(response_data.disk_info).map(([key, value]) => (
                                                    <li key={key}>
                                                        <strong>{key.replace(/_/g, " ")}:</strong> <span style={{ color: value ? "green" : "red",}}> {value?.toString() || "N/A"}</span>
                                                    </li>
                                                ))}
                                            </ul>
                                        </div>
                                    )}
                        
                                    {/* Render Channel List */}
                                    {response_data.channel_list && response_data.channel_list.length > 0 && (
                                        <div>
                                            <h4>Channel List</h4>
                                            <ul>
                                                {response_data.channel_list.map((channel, index) => (
                                                    <li key={index}>
                                                        <strong>Channel ID:</strong><span style={{ color: !channel.channel_id ? "red" : "green"}}> {channel.channel_id || "N/A"}</span> <br />
                                                        <strong>Status:</strong> 
                                                            <span style={{ color: channel.channel_status === "offline" || !channel.channel_status ? "red" : "green"}} >
                                                                {channel.channel_status || "N/A"}
                                                            </span> <br />
                                                        <strong>Name:</strong> <span style={{ color: !channel.name ? "red" : "green"}}>{channel.name || "N/A"} </span><br />
                                                        {/* <strong>Recording Type:</strong>
                                                        <span style={{ color: !channel.recording_type ? "red" : "green"}} >
                                                                {channel.recording_type || "N/A"}
                                                        </span> <br /> */}
                                                        {/* <strong>Recording Status:</strong>
                                                        <span style={{color: channel.recording_status === "no recording" || !channel.recording_status ? "red" : "green"}} >
                                                                {channel.recording_status || "N/A"}
                                                            </span> <br /> */}
                                                        <strong>Resolution:</strong> 
                                                            <span style={{color: !channel.resolution ? "red" : "green"}} >
                                                                {channel.resolution || "N/A"}
                                                            </span><br/>
                                                        <strong>Main Stream Resolution:</strong> 
                                                            <span style={{color: !channel.main_stream_resolution ? "red" : "green"}} >
                                                                {channel.main_stream_resolution || "N/A"}
                                                            </span><br/>
                                                        <strong>Substream Resolution:</strong> 
                                                            <span style={{color: !channel.sub_stream_resolution ? "red" : "green"}} >
                                                                {channel.sub_stream_resolution || "N/A"}
                                                            </span><br/>
                                                        <strong>Substream FPS:</strong> 
                                                            <span style={{color: !channel.sub_stream_fps ? "red" : "green"}} >
                                                                {channel.sub_stream_fps || "N/A"}
                                                            </span><br/>
                                                    </li>
                                                ))}
                                            </ul>
                                        </div>
                                    )}
                        
                        
                                    {/* Render Snapshot Info */}
                                    {response_data.snapshot_info && response_data.snapshot_info.length > 0 && (
                                        <div>
                                            <h4>Snapshot Info</h4>
                                            <ul>
                                                {response_data.snapshot_info.map((snapshot, index) => (
                                                    <li key={index} style={{ color: "green"}}>{snapshot}</li>
                                                ))}
                                            </ul>
                                        </div>
                                    )}

                                    {response_data.time_zone_match !== undefined && (
                                        <div>
                                            <h4>Timezone Info</h4>
                                            <ul>
                                                <li 
                                                    key="site_time_zone" 
                                                    style={{ color: response_data.time_zone_match ? "green" : "red" }}
                                                >
                                                    Site Timezone: {response_data.site_time_zone}
                                                </li>
                                                <li 
                                                    key="device_time_zone" 
                                                    style={{ color: response_data.time_zone_match ? "green" : "red" }}
                                                >
                                                    Device Timezone: {response_data.device_time_zone}
                                                </li>
                                                
                                            </ul>
                                        </div>
                                    )}


                                </div>
                                ) : (
                                    <p>No additional details available.</p>
                                )}
                            </div>
                        </div>
            )}
            
            <div style={{ marginTop:'2.2cm', display: 'flex', justifyContent: 'center', marginBottom: '2.2cm' }}>
              <button id ='rowsPerPageButton' onClick={() => this.handleChangePage(currentPage - 1)} disabled={currentPage === 1}>
                {"< Prev"}
              </button>&emsp;
              <span style={{fontSize:'small'}}>
                {`Page ${currentPage} / ${Math.ceil(filteredDevices.length / rowsPerPage)}`}
              </span>&emsp;
              <button id ='rowsPerPageButton' onClick={() => this.handleChangePage(currentPage + 1)} disabled={currentPage === Math.ceil(filteredDevices.length / rowsPerPage)}>
                {"Next >"}
              </button>

            </div>
          </div>
          {/* Backdrop with Circular Progress */}
          <Backdrop open={this.state.open_progress_bar} style={{ zIndex: "50" }}>
            <div className="custom-spinner">
              <div className="circle"></div>
              <div className="circle tilted"></div>
              <img src={WebLogo} alt="web-logo" style={{backgroundColor:'#001f54', borderRadius:'100px'}}/>
            </div>
            {/* <CircularProgress size={80} color="inherit" /> */}
          </Backdrop>
          {/* <button onClick={this.openDialog}>Delete Item</button> */}
          <DialogBox
                confirmDialog={confirmDialog}
                setConfirmDialog={(updatedDialog) =>
                  this.setState({ confirmDialog: updatedDialog })
                }
                onConfirm={this.state.confirmDialog.onConfirm} // Use the stored callback
                onCancel={this.closeDialog}
              />
          </div>
      </div>
    );
  }
}

export default withNavigate(DevicesList);